// extracted by mini-css-extract-plugin
export var actionText = "_p8-4";
export var container = "_p8-0";
export var leftSection = "_p8-1";
export var rightSection = "_p8-2";
export var settingsButton = "_p8-6";
export var settingsIcon = "_p8-7";
export var shortcut = "_p8-5";
export var shortcutGroup = "_p8-3";